import { SvgIcon, SvgIconProps } from "@mui/material";

const OverviewIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="22" height="22" viewBox="0 0 22 22" fill="none">
      <g xmlns="http://www.w3.org/2000/svg" id="Icon">
        <path
          d="M21.0006 11.1171C21.0006 5.5296 16.471 1 10.8835 1C6.34846 1 2.51036 3.98385 1.22531 8.0954C1.143 8.35878 1.10184 8.49047 1.10572 8.65514C1.10888 8.78904 1.14958 8.95446 1.20891 9.07454C1.28188 9.22222 1.39454 9.33488 1.61986 9.56018L12.4409 20.3807C12.6662 20.606 12.7788 20.7187 12.9265 20.7916C13.0466 20.8509 13.212 20.8916 13.3459 20.8948C13.5106 20.8987 13.6423 20.8575 13.9057 20.7752C18.017 19.49 21.0006 15.652 21.0006 11.1171Z"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.4468 8.7341C2.6873 8.71699 2.93013 8.70829 3.17499 8.70829C8.76253 8.70829 13.2921 13.2379 13.2921 18.8254C13.2921 19.0703 13.2834 19.3131 13.2663 19.5536C13.2364 19.9738 13.2215 20.1839 13.099 20.3137C12.9995 20.4191 12.8298 20.4824 12.6856 20.468C12.508 20.4502 12.3466 20.2887 12.0236 19.9658L2.03464 9.97679C1.71171 9.65385 1.55024 9.49239 1.53246 9.31484C1.51801 9.17064 1.58136 9.00088 1.68675 8.9014C1.81651 8.77892 2.02661 8.76398 2.4468 8.7341Z"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
};

const ProfessionalInfoIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M20 9.5V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H14M14 11H8M10 15H8M16 7H8M16.5 15.0022C16.6762 14.5014 17.024 14.079 17.4817 13.81C17.9395 13.5409 18.4777 13.4426 19.001 13.5324C19.5243 13.6221 19.999 13.8942 20.3409 14.3004C20.6829 14.7066 20.87 15.2207 20.8692 15.7517C20.8692 17.2506 18.6209 18 18.6209 18M18.6499 21H18.6599"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

const SkillsIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M16 4C16.93 4 17.395 4 17.7765 4.10222C18.8117 4.37962 19.6204 5.18827 19.8978 6.22354C20 6.60504 20 7.07003 20 8V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V8C4 7.07003 4 6.60504 4.10222 6.22354C4.37962 5.18827 5.18827 4.37962 6.22354 4.10222C6.60504 4 7.07003 4 8 4M9 15L11 17L15.5 12.5M9.6 6H14.4C14.9601 6 15.2401 6 15.454 5.89101C15.6422 5.79513 15.7951 5.64215 15.891 5.45399C16 5.24008 16 4.96005 16 4.4V3.6C16 3.03995 16 2.75992 15.891 2.54601C15.7951 2.35785 15.6422 2.20487 15.454 2.10899C15.2401 2 14.9601 2 14.4 2H9.6C9.03995 2 8.75992 2 8.54601 2.10899C8.35785 2.20487 8.20487 2.35785 8.10899 2.54601C8 2.75992 8 3.03995 8 3.6V4.4C8 4.96005 8 5.24008 8.10899 5.45399C8.20487 5.64215 8.35785 5.79513 8.54601 5.89101C8.75992 6 9.03995 6 9.6 6Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

const PlayingLevelIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M8 14V18M16 12V18M12 8V18M20 6.8V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V6.8C4 5.11984 4 4.27976 4.32698 3.63803C4.6146 3.07354 5.07354 2.6146 5.63803 2.32698C6.27976 2 7.11984 2 8.8 2H15.2C16.8802 2 17.7202 2 18.362 2.32698C18.9265 2.6146 19.3854 3.07354 19.673 3.63803C20 4.27976 20 5.11984 20 6.8Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

const UnCheckedIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="10" height="10" viewBox="0 0 10 10" fill="none">
      <path d="M5 1V9" stroke="#111111" strokeWidth="2" strokeLinecap="round" />
      <path d="M9 5L1 5" stroke="#111111" strokeWidth="2" strokeLinecap="round" />
    </SvgIcon>
  );
};

const CheckedIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="8" height="5" viewBox="0 0 10 9" fill="none">
      <path d="M1 3.61921L3.90909 6.66683L9 1.3335" stroke="white" strokeWidth="2" strokeLinecap="round" />
    </SvgIcon>
  );
};

export { OverviewIcon, ProfessionalInfoIcon, SkillsIcon, PlayingLevelIcon, UnCheckedIcon, CheckedIcon };
